<div class="bulk-action-bar" *ngIf="selectedCount$() > 0">
    <button type="button" class="approve-btn" (click)="approveSelected()">
        {{ 'column.approvals.bulkApprove' | translate: { count: selectedCount$() } }}
    </button>
</div>
